import service from './request'

//获取坐席组列表
export const getGroupList = data => {
  return service({
    url: "/cc/baseData/getGroupList",
    method: "post",
    data
  });
};
//获取用户坐席组列表
export const getGroupListByUserId = data => {
  return service({
    url: "/cc/baseData/getGroupListByUserId",
    method: "post",
    data
  });
};
//获取技能组列表
export const getSkillList = data => {
  return service({
    url: "/cc/baseData/getSkillList",
    method: "post",
    data
  });
};
//根据坐席组获取技能组列表
export const getSkillListByGroup = data => {
  return service({
    url: "/cc/toolbar/getSkillListByGroup",
    method: "post",
    data
  });
};
//获取用户技能组列表
export const getSkillListByUserId = data => {
  return service({
    url: "/cc/baseData/getSkillListByUserId",
    method: "post",
    data
  });
};
//获取用户列表数据
export const getUserList = data => {
  return service({
    url: "/platform/baseData/getUserList",
    method: "post",
    type: "body",
    data
  });
};
//获取用户列表数据
export const getAgentGroupUserList = data => {
  return service({
    url: "/cc/baseData/getAgentGroupUserList",
    method: "post",
    data
  });
};
//获取媒体类型列表
export const getMediaTypeList = data => {
  return service({
    url: "/cc/baseData/getMediaTypeList",
    method: "post",
    data
  });
};
//获取业务类型列表
export const getBusinessTypeList = data => {
  return service({
    url: "/cc/baseData/getBusinessTypeList",
    method: "post",
    data
  });
};
//获取技能元素列表
export const getSkillElementList = data => {
  return service({
    url: "/cc/baseData/getSkillElementList",
    method: "post",
    data
  });
};
//获取通道组列表
export const getChannelGroupList = data => {
  return service({
    url: "/cc/baseData/getChannelGroupList",
    method: "post",
    data
  });
};
//获取短信模板树结构
 export const getSmsTemplateList = data => {
  return service({
      url: '/platform/baseData/getSmsTemplateList',
      method: 'post',
      type: 'body',
      data
  })
}
//获取字典列表数据
export const getDictList = data => {
  return service({
      url: '/platform/baseData/getDictList',
      method: 'post',
      type: 'body',
      data
  })
}

//获取多字典列表数据
export const getDictMap = data => {
  return service({
      url: '/platform/baseData/getDictMap',
      method: 'post',
      type: 'body',
      data
  })
}

//获取字典类型数据
export const getDictType = data => {
  return service({
      url: '/platform/dictType/getList',
      method: 'post',
      type: 'body',
      data
  })
}

//获取坐席初始化信息
export const loginInitGetInfo = params => {
  return service({
    url: '/cc/loginInit/getInfo',
    method: 'post',
    params
  })
};

//更新坐席初始化信息
export const loginInitUpdateData = data => {
  return service({
    url: '/cc/loginInit/updateData',
    method: 'post',
    type: 'body',
    data
  })
};

//分机号是否存在验证
export const baseFunExtNumIsExist = params => {
  return service({
    url: '/cc/baseFun/extNumIsExist',
    method: 'post',
    params
  })
};

//分机号合理性验证
export const baseFunChkExtNum = params => {
  return service({
    url: '/cc/baseFun/chkExtNum',
    method: 'post',
    params
  })
};

//获取agp密码
export const baseFunGetDynamicPwd = params => {
  return service({
    url: '/cc/baseFun/getDynamicPwd',
    method: 'post',
    params
  })
};

//获取坐席工具栏状态列表
export const getAgentStatusList = data => {
  return service({
    url: '/cc/toolbar/getAgentStatusList',
    method: 'post',
    type: 'body',
    data
  })
};

//通过坐席组id获取坐席列表
export const getAgentListByGroupId = data => {
  return service({
    url: '/cc/toolbar/getAgentListByGroupId',
    method: 'post',
    type: 'body',
    data
  })
};

//获取ivr列表数据
export const getIvrList = data => {
  return service({
    url: '/cc/toolbar/getIvrList',
    method: 'post',
    type: 'body',
    data
  })
};

//获取坐席组技能列表数据
export const getGroupSkillList = data => {
  return service({
    url: '/cc/toolbar/getGroupSkillList',
    method: 'post',
    type: 'body',
    data
  })
};

//获取当前坐席的组与技能数据
export const getUserGroupAndSkillList = data => {
  return service({
    url: '/cc/toolbar/getUserGroupAndSkillList',
    method: 'post',
    type: 'body',
    data
  })
};

//查询agp错误码
export const getErrMsgByCode = data => {
  return service({
    url: '/cc/toolbar/getErrMsgByCode',
    method: 'post',
    data
  })
};

//获取坐席及监控状态
export const getAgentAndSkillByGroupIdForMo = data => {
  return service({
    url: '/monitor/getAgentAndSkillByGroupIdForMo',
    method: 'post',
    type: 'body',
    data
  })
};

//获取坐席示忙数和接听数
export const statusCount = data => {
  return service({
    url: '/monitor/statusCount',
    method: 'post',
    type: 'body',
    data
  })
};

//获取工单类型可选数据
export const baseDataGetOrderType = data => {
  return service({
    url: '/crm/baseData/getOrderType',
    method: 'post',
    data
  })
};

//获取工单优先级可选数据
export const baseDataGetOrderPriority = data => {
  return service({
    url: '/crm/baseData/getOrderPriority',
    method: 'post',
    data
  })
};

//获取客户等级数据
export const baseDataGetCusLevel = data => {
  return service({
    url: '/crm/baseData/getCusLevel',
    method: 'post',
    type: 'body',
    data
  })
};

// 根据id获取省市区，省id为0
export const getqueryAreaList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/base/queryAreaList',
    method: 'post',
    type: 'body',
    data
  })
}

// 根据坐席组id技能组id获取坐席列表
export const getAgentListByGroupAndSkill = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/toolbar/getAgentListByGroupAndSkill',
    method: 'post',
    data
  })
}
/**
 * 获取渠道数据
 */
 export const getChannelList = data => {
  return service({
    showLoading: false,
    url: '/platform/baseData/getChannelList',
    method: 'post',
    type: 'body',
    data
  })
}
/**
 * 获取本地手机号前7位
 */
export const getMobileCodeData = data => {
  return service({
    showLoading: false,
    url: '/cc/baseData/getMobileCodeData',
    method: 'post',
    type: 'body',
    data
  })
}
/**
 * 获取业务单元
 */
export const findBuCode = data => {
  return service({
    showLoading: false,
    url: '/platform/user/findBuCode',
    method: 'post',
    type: 'body',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/BaseData.js